import BaseComponent from './BaseComponent';

class HeaderProduct extends BaseComponent {
  constructor(componentName, autoInit){
    super(componentName);
  }


  init(component) {
    // this.addCustomEvents(component);

    const element = component.element;
    const iconSpecs = document.getElementsByClassName('section--header-specs-with-icons')[0];

    if (!!iconSpecs) {
      element.classList.add('header-with-specs');
    } else {
      element.classList.add('header-without-specs');
    }

  }

}

export default HeaderProduct;
